import axios from '../api/axios';
import { useDispatch } from "react-redux";
import { setCredentials } from '../redux/authSlice';


const useRefreshToken = () => {

    const dispatch = useDispatch();


    const refresh = async () => {
        const response = await axios.get('/refresh', {
            withCredentials: true
        });
        dispatch(setCredentials({
            isAdmin: response.data.isAdmin,
            accessToken: response.data.accessToken,
            userId: response.data.userId,
            email: response.data.email
        }));
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;